<template>
    <Success/>
</template>

<script>
// @ is an alias to /src
import Success from '@/components/Success.vue'

export default {
  name: 'buy',
  components: {
    Success
  }
}
</script>
